import React from 'react'
import PropTypes from 'prop-types'

import { Check } from '@aok/icon-linear'
import { PrimaryButton, SecondaryButton, Textarea } from '@aok/ui-elements'

import SmallContentContainer from '../../_layouts/SmallContentContainer/SmallContentContainer'
import AllroundContainer from '../../_layouts/AllroundContainer'

import { useFeedbackForm } from './T010Hooks'
import {
  DEFAULT_ERROR_MESSAGE,
  DESCRIPTION_DEFAULT,
  NO_BUTTON_LABEL,
  SUBMISSION_SUCCESS_MESSAGE,
  SUBMIT_BUTTON_IDLE,
  SUBMIT_BUTTON_PENDING,
  TEXTAREA_LABEL,
  YES_BUTTON_LABEL,
} from './T010Constants'

const T010L = (props) => {
  const { placeholderYes, placeholderNo, navigator } = props

  const description = navigator ? `War ${navigator} hilfreich für Sie?` : DESCRIPTION_DEFAULT

  const {
    handleYesNoButtonClick,
    handleSubmitFeedback,
    handleChangeTextFeedback,
    handleFocusTextFeedback,
    showCompletionMsg,
    buttonClicked,
    showErrorMsg,
    isArticleHelpful,
    formRequestPending,
    hashRequestPending,
  } = useFeedbackForm(props)

  return (
    <AllroundContainer dataTrackingName="T010L">
      {!showCompletionMsg ? (
        <>
          {/* First Step: yes/no question */}
          <hr className="w-full h-0 border-dfe3e6 border-t-2 mb-32" />
          <div className="flex flex-col gap-20 600:flex-row 600:items-center 600:justify-between">
            <p
              id="t010l-description"
              className="
                  font-buenos-aires font-semibold text-005e3f
                  text-28 leading-36
                  1280:text-32 1280:leading-44
                "
            >
              {description}
            </p>

            {/* Yes/No Buttons */}
            <div className="flex flex-col relative 600:flex-row 600:items-end">
              <SecondaryButton
                className="600:w-96 1280:w-112"
                onClick={() => handleYesNoButtonClick(true)}
                aria-describedby="t010l-description"
              >
                {YES_BUTTON_LABEL}
              </SecondaryButton>
              <SecondaryButton
                className="600:w-96 1280:w-112 mt-16 600:mt-0 600:ml-16"
                onClick={() => handleYesNoButtonClick(false)}
                aria-describedby="t010l-description"
              >
                {NO_BUTTON_LABEL}
              </SecondaryButton>
            </div>
          </div>
          {!buttonClicked && <hr className="w-full h-0 border-dfe3e6 border-t-2 mt-32" />}

          {/* Second Step: textual feedback */}
          {buttonClicked && (
            <div className="mt-32 600:mt-24 1000:mt-32">
              <SmallContentContainer isArticleContainer>
                {/* feedback form element */}
                <div className="relative flex flex-col gap-16">
                  <p className="text-20 leading-28 font-semibold font-buenos-aires">{TEXTAREA_LABEL}</p>
                  <div className="relative w-full">
                    <Textarea
                      variant="light"
                      errorMessage={showErrorMsg ? DEFAULT_ERROR_MESSAGE : null}
                      label={TEXTAREA_LABEL}
                      labelVisibility="hide"
                      textareaProps={{
                        'placeholder': `${isArticleHelpful ? placeholderYes : placeholderNo}`,
                        'id': 'text-feedback',
                        'name': 'text-feedback',
                        'rows': 4,
                        'data-is-helpful': isArticleHelpful ? 'yes' : 'no',
                      }}
                      textareaClassName="h-188 600:h-140 840:h-auto"
                      onChange={handleChangeTextFeedback}
                      onFocus={handleFocusTextFeedback}
                    />
                  </div>
                </div>

                {/* Send feedback button */}
                <PrimaryButton
                  className="h-48 w-full mt-32 600:w-auto 600:ml-auto 600:mt-32 1000:mt-40"
                  isDisabled={formRequestPending || hashRequestPending}
                  onClick={handleSubmitFeedback}
                >
                  {formRequestPending ? SUBMIT_BUTTON_PENDING : SUBMIT_BUTTON_IDLE}
                </PrimaryButton>
              </SmallContentContainer>
              <hr className="w-full h-0 border-dfe3e6 border-t-2 mt-32" />
            </div>
          )}
        </>
      ) : (
        <div className="flex items-start justify-start gap-16 1000:items-center">
          <Check className="w-32 h-32 600:w-40 600:h-40 text-18ab42 fill-current shrink-0" />
          <p
            className="
              font-buenos-aires font-semibold text-005e3f
              text-28 leading-36
              1280:text-32 1280:leading-44
            "
          >
            {SUBMISSION_SUCCESS_MESSAGE}
          </p>
        </div>
      )}
    </AllroundContainer>
  )
}

T010L.propTypes = {
  campaign: PropTypes.number,
  client: PropTypes.number,
  navigator: PropTypes.string,
  form: PropTypes.number,
  textfieldNameYes: PropTypes.string,
  textfieldNameNo: PropTypes.string,
  buttonNameYes: PropTypes.string,
  buttonNameNo: PropTypes.string,
  placeholderYes: PropTypes.string,
  placeholderNo: PropTypes.string,
  additionalFormParams: PropTypes.object,
}

T010L.defaultProps = {
  buttonNameYes: 'Button (YES) wurde nicht gesetzt',
  buttonNameNo: 'Button (NO) wurde nicht gesetzt',
  placeholderYes: 'Placeholder (YES) wurde nicht gesetzt',
  placeholderNo: 'Placeholder (NO) wurde nicht gesetzt',
}

export default T010L
